import { Component } from '@angular/core';
import { ScreeningListItemComponent } from 'libs/shared/src/lib/component/screening/list/item/item.component';

@Component({ standalone: false, selector: 'app-screening-list-item', templateUrl: './item.component.html' })
export class CustomScreeningListItemComponent extends ScreeningListItemComponent {}
